<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject">
      <strong>step 5 | Choose your stencil material</strong>
    </div>

    <b-form-group class="mt-4">
      <b-form-radio v-for="material in materials" v-model="selectedMaterial" :value="material.value" :key="material.value" inline>
        <span v-html="material.text"></span>
      </b-form-radio>
    </b-form-group>

    <b-button variant="default" class="mt-4 go-next" v-on:click="goNext">next</b-button>
  </div>
</template>

<script>
import { STENCILCONST } from '../modules/constant.js.erb'

export default {
  computed: {
    selectedMaterial: {
      get: function() {
        return this.$store.state.product.material;
      },
      set: function(value) {
        this.$store.dispatch('product/SET_MATERIAL', value)
      }
    },
    availableMaterials: function() {
      return STENCILCONST.material.filter(
        material => this.$store.state.product.materials.includes(material.value)
      )
    },
    materials: function() {
      let real_h = this.$store.state.product.textHeight;

      if(real_h < 4) {
         return this.availableMaterials.filter(
           m =>
           (m.value != "Duraflex; 125 mil Contractor Grade") &&
           (m.value != "UltraFlex&trade; 60 mil Industrial Grade")
         )
      } else {
        return this.availableMaterials;
      }
    },
  },
  methods: {
    goNext(evt) {
      this.$store.dispatch('product/SET_OLDTAB', 4)
      this.$store.dispatch('product/SET_ACTIVETAB', 4)
      this.$store.dispatch('product/SET_ACTIVETAB', 5)
    }
  }
}
</script>
